import { cn } from "@/lib/utils";
import { FC } from "react";
import { NavLink, useLocation } from "react-router-dom";

export type NavigationItemProps = {
  label: string;
  href: string;
  isDefaultActive?: boolean;
};

const NavigationItem: FC<NavigationItemProps> = (props) => {
  const href = `./${props.href}`;
  const location = useLocation();

  return (
    <NavLink to={{ pathname: href, search: location.search }}>
      {({ isActive }) => (
        <div
          className={cn(
            "flex items-center gap-2 border-[0.5px] border-white px-5 py-2 text-center text-sm text-[#8090A3] transition-all duration-300 ease-in-out hover:text-black",
            isActive && "rounded-full border-black font-bold text-black",
          )}
        >
          {props.label}
        </div>
      )}
    </NavLink>
  );
};

export default NavigationItem;
